/* Result testimonials only. Original Judge.me reviews and aggregate ratings stay intact.
 * Loaded after the landing shell has read its configuration, before the quiz bundle.
 */
(function () {
  'use strict';
  const excludedQuote = 'Tienen muy buena pinta, pero lamentablemente a ninguno de mis 5 gatos les gustó... Una pena :-(';
  const normalize = value => typeof value === 'string'
    ? value.normalize('NFKC').trim().replace(/\s+/gu, ' ').toLocaleLowerCase('es') : '';
  function excluded(voice) {
    if (!voice || normalize(voice.reviewer) !== 'raq') return false;
    return normalize(voice.quote) === normalize(excludedQuote)
      || (typeof voice.publishedAt === 'string' && voice.publishedAt.startsWith('2026-09-19T21:35:22'));
  }
  for (const node of document.querySelectorAll('script[type="application/json"][id^="cm-qv2-config-"]')) {
    try {
      const config = JSON.parse(node.textContent || '{}');
      const proof = config.reviewProof;
      if (!proof || typeof proof !== 'object') continue;
      let changed = false;
      for (const key of ['contextVoices', 'recentVoices']) {
        if (!Array.isArray(proof[key])) continue;
        const filtered = proof[key].filter(voice => !excluded(voice));
        if (filtered.length !== proof[key].length) { proof[key] = filtered; changed = true; }
      }
      if (excluded(proof.latest)) { proof.latest = null; changed = true; }
      if (changed) node.textContent = JSON.stringify(config).replace(/</g, '\\u003c');
    } catch (_) { /* A review selection issue must never interrupt the quiz. */ }
  }
}());
